import React, { useId } from "react";
export default function Checkbox({ label, description, className = "", id: idProp, ...props }: React.InputHTMLAttributes<HTMLInputElement> & {
    label?: React.ReactNode;
    description?: React.ReactNode;
    className?: string;
    id?: string;
}): any {
    const autoId = useId();
    const id = idProp ?? autoId;
    return (<label htmlFor={id} className={`flex items-start gap-2.5 cursor-pointer select-none ${className}`}>
      <input type="checkbox" id={id} className="mt-0.5 h-4 w-4 rounded border-border-strong text-brand-600 focus:ring-brand-500" {...props}/>
      <span className="flex flex-col">
        {label && <span className="text-sm text-fg leading-5">{label}</span>}
        {description && (<span className="text-xs text-fg-subtle leading-snug">{description}</span>)}
      </span>
    </label>);
}
